import(/* webpackMode: "eager", webpackExports: ["BarChart"] */ "/vercel/path0/components/ui/chart.tsx");
